import { gql } from 'graphql-request';
import { merchantServiceGraphql, userToken } from '../config/Config';

export const getListItem = async (page, rowPerPage, keyword, categoryID) => {
  const LIST_ITEM = gql`
    query AllItems(
      $page: Int
      $perPage: Int
      $sortField: String
      $sortOrder: String
      $filter: ItemFilter
    ) {
      items: allItems(
        page: $page
        perPage: $perPage
        sortField: $sortField
        sortOrder: $sortOrder
        filter: $filter
      ) {
        id
        name
        price
        quantity
        status
        unit
        attributes
        categoryID
        created_at
        description
        updated_at
        updated_by
      }
      total: _allItemsMeta(
        page: $page
        perPage: $perPage
        sortField: $sortField
        sortOrder: $sortOrder
        filter: $filter
      ) {
        count
      }
    }
  `;
  const requestData = {
    page: page,
    perPage: rowPerPage,
    filter: {
      categoryID: categoryID,
      name: keyword,
    },
  };
  const response = await merchantServiceGraphql.request(LIST_ITEM, requestData);
  return response;
};

export const createItem = async (data) => {
  const CREATE_ITEM = gql`
    mutation CreateItem(
      $categoryId: Int!
      $name: String!
      $description: String
      $attributes: String
      $unit: String!
      $price: Float!
      $quantity: Float!
    ) {
      createItem(
        categoryID: $categoryId
        name: $name
        description: $description
        attributes: $attributes
        unit: $unit
        price: $price
        quantity: $quantity
      ) {
        id
        description
        categoryID
        name
        price
        quantity
        status
        unit
      }
    }
  `;
  const response = await merchantServiceGraphql.request(CREATE_ITEM, data);
  return response.createItem;
};

export const deleteItem = async (data, password) => {
  const DELETE_ITEM = gql`
    mutation UpdateStatusItem($itemId: Int!, $status: Int!) {
      updateStatusItem(id: $itemId, status: $status) {
        id
        name
        price
        quantity
        status
        unit
        attributes
        categoryID
      }
    }
  `;
  const requestHeaders = {
    authorization: userToken,
    Password: password,
  };
  const response = await merchantServiceGraphql.request(
    DELETE_ITEM,
    data,
    requestHeaders
  );
  return response.updateStatusItem;
};

export const updateItem = async (data) => {
  const UPDATE_ITEM = gql`
    mutation UpdateItem(
      $itemId: Int!
      $name: String
      $description: String
      $attributes: String
      $status: Int
      $price: Float
      $unit: String
      $quantity: Float
    ) {
      updateItem(
        id: $itemId
        name: $name
        description: $description
        attributes: $attributes
        status: $status
        price: $price
        unit: $unit
        quantity: $quantity
      ) {
        id
        name
        price
        quantity
        status
        unit
        updated_at
        description
        attributes
      }
    }
  `;
  const response = await merchantServiceGraphql.request(UPDATE_ITEM, data);
  return response.updateItem;
};
